// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__i2kms","footer":"ModalError_footer__1VwNG"};